/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { Button } from '@mui/material';

import { Namespaces } from '../../i18n';
import { createLinkSuccessfulStyles } from './LinkSuccessful.styles';

export const LinkSuccessful = memo(() => {
  const { t } = useTranslation(Namespaces.Common);
  const classes = createLinkSuccessfulStyles();
  return (
    <div className={classes.root}>
      <h3 className={classes.title}>{t('link_expired.email_successful')}</h3>
      <NavLink to={'/'} className={classes.link}>
        <Button type="submit" color="primary" variant="contained" size="large">
          {t('link_expired.button')}
        </Button>
      </NavLink>
    </div>
  );
});
